// Data sources for the taxi site
export const ASSETS = {
  hero: "https://customer-assets.emergentagent.com/job_taxi-piraeus-port/artifacts/8by81pbl_Acroplis-Athens.jpg",
  airport: "https://customer-assets.emergentagent.com/job_taxi-piraeus-port/artifacts/ri2s1at6_airport_aerodromio_shutterstock-768x480.jpg",
  port: "https://customer-assets.emergentagent.com/job_taxi-piraeus-port/artifacts/snm64wor_limani-02.jpg",
  athensTourCollage:
    "https://customer-assets.emergentagent.com/job_57e2afb5-08ee-4995-b455-126b782b25f9/artifacts/8mzhsotq_file_00000000f6cc71fbb49a7022cf5ce2fc.png",
  taxi1: "/generated/athens_taxi_1.png",
  taxi2: "/generated/athens_taxi_2.png",
  ourTaxi: "https://customer-assets.emergentagent.com/job_piraeus-cab-service/artifacts/x3z1d36x_IMG-a7624138561c66a89d435614dc59161b-V.jpg",
  ourTaxi3: "/uploads/our-taxi-3.jpg",
  ourTaxi2: "https://customer-assets.emergentagent.com/job_piraeus-cab-service/artifacts/vtwgqxdy_IMG-20260615-WA0072.jpg",
  ourTaxiInterior: "https://customer-assets.emergentagent.com/job_piraeus-cab-service/artifacts/nd91wqqm_file_00000000620c71fbb9196bc4cf21be96.png",
  sounion: "/uploads/sounion.jpg",
  delphi:
    "https://images.unsplash.com/photo-1761906270046-85545d6011ff?auto=format&fit=crop&w=1200&q=80",
  corinth:
    "https://images.unsplash.com/photo-1748560549566-e70d01cf387d?auto=format&fit=crop&w=1200&q=80",
  mycenaeNafplio:
    "https://images.unsplash.com/photo-1687901807868-7fa78c20193e?auto=format&fit=crop&w=1200&q=80",
  olympia:
    "https://images.unsplash.com/photo-1777967200018-2f6f6c5583f2?auto=format&fit=crop&w=1200&q=80",
  meteora:
    "https://images.unsplash.com/photo-1740488003957-8e04d69406cb?auto=format&fit=crop&w=1200&q=80",
  rafina: "/uploads/rafina.jpg",
  lavrio: "https://customer-assets.emergentagent.com/job_piraeus-cab-service/artifacts/9sccq5o8_shutterstock_limenas_lauriou.jpg",
};

export const LOCATIONS = [
  { id: "ath", label: "Athens International Airport (Eleftherios Venizelos)", alt: "διεθνής αερολιμένας αθηνών ελευθέριος βενιζέλος ath spata σπάτα αεροδρόμιο" },
  { id: "ath-arr", label: "Athens Airport — Arrivals", alt: "αεροδρόμιο αφίξεις arrivals" },
  { id: "ath-dep", label: "Athens Airport — Departures", alt: "αεροδρόμιο αναχωρήσεις departures" },
  { id: "piraeus", label: "Piraeus Port", alt: "πειραιάς λιμάνι piraeus port" },
  { id: "piraeus-e1", label: "Piraeus Port — Gate E1", alt: "πειραιάς πύλη ε1" },
  { id: "piraeus-e2", label: "Piraeus Port — Gate E2", alt: "πειραιάς πύλη ε2" },
  { id: "piraeus-e3", label: "Piraeus Port — Gate E3", alt: "πειραιάς πύλη ε3" },
  { id: "piraeus-e7", label: "Piraeus Port — Gate E7 (Cruise terminal)", alt: "πειραιάς πύλη ε7 cruise" },
  { id: "piraeus-e9", label: "Piraeus Port — Gate E9", alt: "πειραιάς πύλη ε9" },
  { id: "piraeus-e12", label: "Piraeus Port — Gate E12", alt: "πειραιάς πύλη ε12" },
  { id: "rafina", label: "Rafina Port", alt: "ραφήνα λιμάνι rafina" },
  { id: "lavrio", label: "Lavrio Port", alt: "λαύριο λιμάνι lavrio" },
  { id: "syntagma", label: "Syntagma Square", alt: "σύνταγμα πλατεία syntagma" },
  { id: "monastiraki", label: "Monastiraki Square", alt: "μοναστηράκι μοναστηρακι" },
  { id: "plaka", label: "Plaka", alt: "πλάκα plaka" },
  { id: "acropolis", label: "Acropolis", alt: "ακρόπολη acropolis" },
  { id: "athens-center", label: "Athens City Center", alt: "κέντρο αθήνας athens" },
  { id: "glyfada", label: "Glyfada", alt: "γλυφάδα glyfada" },
  { id: "voula", label: "Voula", alt: "βούλα voula" },
  { id: "vouliagmeni", label: "Vouliagmeni", alt: "βουλιαγμένη vouliagmeni" },
  { id: "kifisia", label: "Kifisia", alt: "κηφισιά kifisia" },
  { id: "marousi", label: "Marousi", alt: "μαρούσι marousi" },
  { id: "kallithea", label: "Kallithea", alt: "καλλιθέα kallithea" },
  { id: "athens-riviera", label: "Athens Riviera", alt: "αθηναϊκή ριβιέρα riviera" },
];

export const ROUTES = [
  {
    id: "airport-center",
    title: "Athens Airport ↔ City Center",
    subtitle: "From and to Athens Airport — City Center",
    fromLabel: "Airport",
    toLabel: "City Center",
    image: ASSETS.airport,
    day: 55,
    night: 70,
    nightHours: "22:30 – 05:00",
  },
  {
    id: "port-center",
    title: "Piraeus Port ↔ City Center",
    subtitle: "From and to Piraeus Port — City Center",
    fromLabel: "Piraeus Port",
    toLabel: "City Center",
    image: ASSETS.port,
    day: 30,
    night: 35,
    nightHours: "22:30 – 05:00",
  },
  {
    id: "airport-port",
    title: "Athens Airport ↔ Piraeus Port",
    subtitle: "From and to Athens Airport — Piraeus Port",
    fromLabel: "Airport",
    toLabel: "Piraeus Port",
    image: ASSETS.port,
    day: 70,
    night: 85,
    nightHours: "22:30 – 05:00",
  },
  {
    id: "rafina-center",
    title: "Rafina Port ↔ City Center",
    subtitle: "From and to Rafina Port — City Center",
    fromLabel: "Rafina Port",
    toLabel: "City Center",
    image: ASSETS.rafina,
    day: 50,
    night: 65,
    nightHours: "22:30 – 05:00",
  },
  {
    id: "rafina-airport",
    title: "Rafina Port ↔ Athens Airport",
    subtitle: "From and to Rafina Port — Athens Airport",
    fromLabel: "Rafina Port",
    toLabel: "Airport",
    image: ASSETS.rafina,
    day: 35,
    night: 45,
    nightHours: "22:30 – 05:00",
  },
  {
    id: "airport-lavrio",
    title: "Athens Airport ↔ Lavrio Port",
    subtitle: "From and to Athens Airport — Lavrio Port",
    fromLabel: "Airport",
    toLabel: "Lavrio Port",
    image: ASSETS.lavrio,
    day: 65,
    night: 80,
    nightHours: "22:30 – 05:00",
  },
];

export const ATHENS_TOUR_STOPS = [
  "Acropolis",
  "Acropolis Museum",
  "Temple of Olympian Zeus",
  "Panathenaic Stadium",
  "Changing of the Guard at Parliament",
  "Athenian Trilogy — Academy, University & Library of Athens",
];

export const TOURS = [
  {
    id: "athens-city",
    title: "Athens City Tour",
    duration: "4 hours",
    price: "€160",
    image: ASSETS.hero,
    blurb:
      "Half-day private tour with all the Athenian landmarks. 6 iconic stops, one comfortable taxi, one English-speaking driver.",
    stops: ATHENS_TOUR_STOPS,
    fixed: true,
  },
  {
    id: "sounion",
    title: "Cape Sounion & Temple of Poseidon",
    duration: "5 hours",
    price: "€200",
    image: ASSETS.sounion,
    blurb: "Sunset tour along the Athens Riviera to Cape Sounion.",
    stops: [
      "Athens Riviera coastline (Glyfada · Voula · Vouliagmeni)",
      "Photo stop at Lake Vouliagmeni",
      "Anavyssos scenic viewpoint",
      "Temple of Poseidon at Cape Sounion",
      "Sunset over the Aegean Sea",
    ],
    fixed: false,
  },
  {
    id: "corinth",
    title: "Ancient Corinth",
    duration: "6 hours",
    price: "€240",
    image: ASSETS.corinth,
    blurb:
      "Visit the Temple of Apollo, the Archaeological Museum and the impressive ruins of Ancient Corinth.",
    stops: [
      "Corinth Canal photo stop",
      "Ancient Corinth archaeological site",
      "Temple of Apollo",
      "Bema (Saint Paul's tribunal)",
      "Archaeological Museum of Ancient Corinth",
      "Acrocorinth panoramic viewpoint",
    ],
    fixed: false,
  },
  {
    id: "delphi",
    title: "Delphi Day Trip",
    duration: "9 hours",
    price: "€360",
    image: ASSETS.delphi,
    blurb: "Full-day excursion to the ancient oracle of Delphi.",
    stops: [
      "Drive through Mount Parnassus",
      "Sanctuary of Apollo & Sacred Way",
      "Temple of Apollo",
      "Ancient Theatre of Delphi",
      "Tholos at the Sanctuary of Athena Pronaia",
      "Castalian Spring",
      "Delphi Archaeological Museum",
      "Lunch in Arachova mountain village",
    ],
    fixed: false,
  },
  {
    id: "mycenae-nafplio-epidaurus",
    title: "Nafplio, Mycenae & Epidaurus",
    duration: "10 hours",
    price: "€400",
    image: ASSETS.mycenaeNafplio,
    blurb:
      "Three Peloponnese highlights in one day — the Mycenaean citadel of Agamemnon, the seaside old town of Nafplio and the legendary Theatre of Epidaurus.",
    stops: [
      "Corinth Canal photo stop",
      "Mycenae — Lion Gate & royal citadel",
      "Treasury of Atreus (Tomb of Agamemnon)",
      "Nafplio Old Town & seafront",
      "Palamidi Fortress viewpoint",
      "Theatre of Epidaurus",
      "Sanctuary of Asclepius",
    ],
    fixed: false,
  },
  {
    id: "meteora",
    title: "Meteora",
    duration: "11 hours",
    price: "€440",
    image: ASSETS.meteora,
    blurb:
      "Long-haul private tour to the breathtaking monasteries of Meteora.",
    stops: [
      "Drive through Central Greece & Thermopylae",
      "Kalambaka village",
      "Great Meteoron Monastery",
      "Varlaam Monastery",
      "Roussanou Monastery",
      "Holy Trinity Monastery",
      "Panoramic Meteora viewpoint",
    ],
    fixed: false,
  },
  {
    id: "olympia",
    title: "Ancient Olympia",
    duration: "11 hours",
    price: "€440",
    image: ASSETS.olympia,
    blurb:
      "Visit the birthplace of the Olympic Games — temples, stadium and archaeological museum.",
    stops: [
      "Corinth Canal photo stop",
      "Drive through the Peloponnese countryside",
      "Sanctuary of Olympia",
      "Temple of Zeus",
      "Temple of Hera",
      "Ancient Olympic Stadium",
      "Workshop of Pheidias",
      "Archaeological Museum of Olympia",
    ],
    fixed: false,
  },
];

export const FEATURES = [
  {
    icon: "languages",
    title: "English-speaking drivers",
    text: "Licensed, friendly professionals who know Athens inside-out.",
  },
  {
    icon: "plug",
    title: "In-car phone chargers",
    text: "iPhone & USB-C cables on board — your phone is never empty.",
  },
  {
    icon: "droplet",
    title: "Complimentary bottled water",
    text: "Chilled water bottles offered on every ride.",
  },
  {
    icon: "tag",
    title: "Fixed prices — no surprises",
    text: "Flat rates with no meter and no hidden fees, paid securely online.",
  },
  {
    icon: "clock",
    title: "24/7 service, 365 days a year",
    text: "Day, night, weekends and holidays — we are always available.",
  },
];

export const REVIEWS = [
  {
    id: "maria-uk",
    name: "Maria T.",
    origin: "London, UK",
    rating: 5,
    text:
      "Booked the airport pickup at 1am and our driver was already waiting with a name sign. Spotless car, smooth ride, fair price — exactly what we needed after a long flight.",
    trip: "Airport → Athens Center",
  },
  {
    id: "david-us",
    name: "David K.",
    origin: "New York, USA",
    rating: 5,
    text:
      "Did the Cape Sounion sunset tour with my family. Our driver spoke perfect English, made great photo stops along the Riviera and waited patiently at the temple. Highly recommend.",
    trip: "Cape Sounion Tour",
  },
  {
    id: "anna-de",
    name: "Anna S.",
    origin: "Berlin, Germany",
    rating: 5,
    text:
      "We had a cruise to catch in Piraeus and they tracked our flight perfectly. No waiting, no stress, flat price as agreed. Will book again on our next trip to Greece.",
    trip: "Airport → Piraeus Port",
  },
];

export const CONTACT = {
  phone: "+30 695 612 8090",
  phoneRaw: "306956128090",
  email: "info@athensairporttaxitransfers.com",
  bookingEmail: "booking@athensairporttaxitransfers.com",
  address: "Athinas 20, Athina 105 51, Greece",
};

export const TID = {
  // Nav
  navHome: "nav-home",
  navServices: "nav-services",
  navTours: "nav-tours",
  navBooking: "nav-booking",
  navContact: "nav-contact",
  navBookBtn: "nav-book-button",

  // Hero
  heroBookBtn: "hero-book-button",
  heroQuoteBtn: "hero-quote-button",

  // Pricing
  pricingSection: "pricing-section",
  pricingCard: (id) => `pricing-card-${id}`,
  pricingBookBtn: (id) => `pricing-book-${id}`,

  // Waiting policy
  waitingSection: "waiting-section",
  waitingAirport: "waiting-airport",
  waitingPort: "waiting-port",
  waitingDeparture: "waiting-departure",

  // Tours
  toursSection: "tours-section",
  tourCard: (id) => `tour-card-${id}`,

  // Booking
  bookingSection: "booking-section",
  bookingForm: "booking-form",
  bookingName: "booking-name",
  bookingEmail: "booking-email",
  bookingPhone: "booking-phone",
  bookingFlight: "booking-flight",
  bookingDate: "booking-date",
  bookingTime: "booking-time",
  bookingPickup: "booking-pickup",
  bookingDropoff: "booking-dropoff",
  bookingService: "booking-service",
  bookingPassengers: "booking-passengers",
  bookingLuggage: "booking-luggage",
  bookingNotes: "booking-notes",
  bookingSubmit: "booking-submit",
  bookingSuccess: "booking-success",
  passengersInc: "passengers-increment",
  passengersDec: "passengers-decrement",
  luggageInc: "luggage-increment",
  luggageDec: "luggage-decrement",

  // Quote
  quoteSection: "quote-section",
  quoteForm: "quote-form",
  quoteName: "quote-name",
  quoteEmail: "quote-email",
  quotePhone: "quote-phone",
  quoteDate: "quote-date",
  quotePassengers: "quote-passengers",
  quoteRoute: "quote-route",
  quoteNotes: "quote-notes",
  quoteSubmit: "quote-submit",
  quoteSuccess: "quote-success",

  // Reviews
  reviewsSection: "reviews-section",
  reviewCard: (id) => `review-card-${id}`,

  // Floating WhatsApp
  floatingWhatsapp: "floating-whatsapp",

  // Contact
  contactSection: "contact-section",
  contactWhatsapp: "contact-whatsapp",
  contactCall: "contact-call",
  contactEmail: "contact-email",
};
